<template>
  <div class="row">
    <div class="col">
      <label>Wybierz składnik:</label>
      <div class="row">
        <div class="col-1">
          <ecoConventionIcon :productType="this.selectedItem?.couverture?.recipeType ?? 0" />
        </div>
        <div class="col-11">
          <v-select :options="couvertures" label="name" v-model="selectedItem.couverture"></v-select>
        </div>

      </div>
    </div>
    <div class="col">
      <label>Waga</label>
      <input type="number" class="form-control" step="0.001" v-model="selectedItem.couvertureWeight" />
    </div>
  </div>
</template>

<script>
import ecoConventionIcon from '../../../../common/ecoConventionIcon.vue'

export default {
  name: "recipeAdministrationItem",
  components: { ecoConventionIcon },
  computed: {
    couvertures() {
      return this.$store.state.couvertureFormData.recipes;
    },
  },
  mounted() {
    this.$store.dispatch("getDeliveryFromData");
  },
  props: ["selectedItem", "products"],
};
</script>